import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, AdminRole } from './AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: AdminRole;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { admin, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-950">
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    );
  }

  if (!admin) return <Navigate to="/proadmin/auth" replace />;
  if (requiredRole && admin.role !== requiredRole) return <Navigate to="/proadmin/users" replace />;

  return <>{children}</>;
};

export default ProtectedRoute;
